import { LocaleProvider } from '../../i18n/LocaleContext';
import type { Locale } from '../../messages';
import { Home } from '../Home';

interface Props {
  locale: Locale;
}

export const LocalePage = ({ locale }: Props) => (
  <LocaleProvider locale={locale}>
    <Home />
  </LocaleProvider>
);
